import {
  FaHtml5,
  FaCss3Alt,
  FaSass,
  FaJsSquare,
  FaReact,
  FaGit,
  FaGithub,
  FaFigma,
  FaNodeJs,
} from 'react-icons/fa';
import { SiGreensock, SiVisualstudiocode } from 'react-icons/si';

export const skills = [
  { name: 'HTML5', grid: 'html', icon: <FaHtml5 /> },
  { name: 'CSS3', grid: 'css', icon: <FaCss3Alt /> },
  { name: 'SCSS', grid: 'sass', icon: <FaSass /> },
  { name: 'Javascript', grid: 'js', icon: <FaJsSquare /> },
  { name: 'GSAP', grid: 'gsap', icon: <SiGreensock /> },
  { name: 'React', grid: 'react', icon: <FaReact /> },
  { name: 'Git', grid: 'git', icon: <FaGit /> },
  { name: 'Github', grid: 'github', icon: <FaGithub /> },
  { name: 'VSCode', grid: 'vsc', icon: <SiVisualstudiocode /> },
  { name: 'Figma', grid: 'figma', icon: <FaFigma /> },
  { name: 'Node', grid: 'node', icon: <FaNodeJs /> },
];
